import { useParams } from "react-router-dom";
import { serviceData } from "./destinationdata";
import Banner from "../Components/Banner";
import pattern from '../Assets/careerbannerpattern.png'
import Breadcrumb from './../Components/Breadcrumb';
import StudyInAmerica from './../Components/Destinations/StudyInAmerica';
import SpecializedCoursesCarousel from "../Components/Services/ServiceWhyChoose/SpecializedCoursesCarousel";
import Faqsectiondest from "../Components/Destinations/Faqsectiondest";
import Programs from "../Components/Programs";
import DestinationCarousel from "../Components/DestinationCarousel";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getPageMeta } from "./MetaTags";

const DynamicPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const { id } = useParams();
  const pageData = serviceData.find(item => item.id === id);
  const pageMeta = getPageMeta(`/destinations/${id}`);

  if (!pageData) {
    return <h2>Page Not Found</h2>;
  }

  // ✅ Format country name properly
  const formatCountry = (name) => {
    const map = {
      USA: "USA",
      UK: "UK",
      NewZealand: "New Zealand"
    };
    return map[name] || name;
  };

  const countryName = formatCountry(id);

  // ✅ FAQ SCHEMA (DYNAMIC)
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": `Why study in ${countryName}?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `Studying in ${countryName} offers globally recognized universities, quality education, and strong career opportunities.`
        }
      },
      {
        "@type": "Question",
        "name": `What are the requirements to study in ${countryName}?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You need academic transcripts, IELTS/TOEFL/PTE scores, a valid passport, and a student visa."
        }
      },
      {
        "@type": "Question",
        "name": `What is the cost of studying in ${countryName}?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The cost depends on the university and course, including tuition fees and living expenses. Scholarships may be available."
        }
      },
      {
        "@type": "Question",
        "name": `Can I work while studying in ${countryName}?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, most countries allow part-time work during studies and full-time during holidays."
        }
      },
      {
        "@type": "Question",
        "name": `How can Nova EduBridge help me study in ${countryName}?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We provide complete support including university selection, applications, visa assistance, and pre-departure guidance."
        }
      }
    ]
  };

  // Wrapper for animation
  const MotionWrapper = ({ children }) =>
    isMobile ? <div>{children}</div> : (
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        {children}
      </motion.div>
    );

  return (
    <>
      {/* ✅ SCHEMA ADDED HERE */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div>
        {/* Banner */}
        <MotionWrapper>
          <Banner
            className='position-relative'
            subtitle={pageData.bannersubtitle}
             title={pageMeta.h1 || `${pageData.bannertitleone}${pageData.bannertitletwo ? ' ' + pageData.bannertitletwo : ''}`}
            buttonText="Contact Us"
            buttonLink="/Contact"
            backgroundImage={pageData.bannerbgimg}
          />
          <div className='position-absolute pattern'>
            <img src={pattern} alt='pattern' />
          </div>
        </MotionWrapper>

        {/* Breadcrumb */}
        <MotionWrapper>
          <Breadcrumb />
        </MotionWrapper>

        {/* Study Section */}
        <MotionWrapper>
          <StudyInAmerica
            heading1={pageData.heading1}
            img1={pageData.img1}
            para1={pageData.para1}
            heading2={pageData.heading2}
            img2={pageData.img2}
            para2={pageData.para2}
          />
        </MotionWrapper>

        {/* Courses */}
        <MotionWrapper>
          <SpecializedCoursesCarousel
            title={pageData.carouseltitle}
            subtitle={pageData.carouselsubtitle}
            courses={pageData.carousellist}
            seeAllLink="/courses"
          />
        </MotionWrapper>

        {/* FAQ UI */}
        <MotionWrapper>
          <Faqsectiondest items={pageData.milestones} />
        </MotionWrapper>

        {/* Programs */}
        <MotionWrapper>
          <Programs />
        </MotionWrapper>

        {/* Destination Carousel */}
        <MotionWrapper>
          <DestinationCarousel />
        </MotionWrapper>
      </div>
    </>
  );
};

export default DynamicPage;
